<motif-modal-title variant="alt">
    <h3>
        <motif-icon [src]="'/assets/icons/alert/ic_warning_24px.svg'"></motif-icon>
        Session Expiry Warning
    </h3>
    <button motifIconButton aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon [src]="'/assets/icons/navigation/ic_close_24px.svg'"></motif-icon>    </button>
</motif-modal-title>
<motif-modal-content>
    <p> Your session will get timed out soon! </p>
    <h2> {{sessionRemainingTime}} </h2>
</motif-modal-content>
<motif-modal-actions>
    <button motifButton 
        color="primary" 
        (click)="renewSession()"
        aria-label="Delete" role="button">
        Renew Session
    </button>
    <button motifButton motif-modal-close color="secondary" aria-label="Cancel" role="button">Cancel</button>
</motif-modal-actions>
